// src/realtime/pgbroadcastSingleton.ts
import { PGBroadcastClient } from "./pgbroadcast";
import { getToken } from "../keycloak";
import { VARCONFIG } from "../varconfig";

// single instance for entire app
let client: PGBroadcastClient | null = null;

// ref-count subscriptions across the whole app
const topicRefCount = new Map<string, number>();

export function pgActiveSubCount(): number {
  let n = 0;
  for (const v of topicRefCount.values()) n += v;
  return n;
}

export function pgActiveTopics(): string[] {
  return Array.from(topicRefCount.keys()).sort();
}

export function getPGBroadcastClient(): PGBroadcastClient {
  if (!client) {
    client = new PGBroadcastClient(
      VARCONFIG.WS_URL,
      () => getToken() ?? undefined,
    );
  }
  return client;
}

// safe subscribe: only actually subscribe on first consumer
export function pgSubscribe(topic: string) {
  const c = getPGBroadcastClient();
  const n = topicRefCount.get(topic) ?? 0;
  if (n === 0) c.subscribe(topic);
  topicRefCount.set(topic, n + 1);
}

// safe unsubscribe: only actually unsubscribe when last consumer leaves
export function pgUnsubscribe(topic: string) {
  const c = getPGBroadcastClient();
  const n = topicRefCount.get(topic) ?? 0;
  if (n <= 1) {
    topicRefCount.delete(topic);
    c.unsubscribe(topic);
  } else {
    topicRefCount.set(topic, n - 1);
  }
}
